const Phaser = window?.Phaser;
export class GameOver extends window.Phaser.Scene {
  constructor() {
    super('gameOver');
  }

  init(data) {
    this.numPlayers = 1;
    this.scores = [];
    this.score = null;
    if (data.numPlayers && data.numPlayers > 1) {
      this.numPlayers = data.numPlayers;
      this.scores = data.scores.slice(0, this.numPlayers);
    } else {
      this.score = data.score;
    }
    this.mode = data.mode;
  }

  preload() { }

  create() {
    this.gameWidth = this.sys.game.canvas.width;
    this.gameHeight = this.sys.game.canvas.height;
    this.gameOver = this.add
      .bitmapText(
        this.gameWidth / 2,
        this.gameHeight / 4,
        'pixelfont',
        'Game Over!',
        32
      )
      .setOrigin(0.5, 0.5);
    let finalScoreText = '';
    if (this.scores && this.scores.length > 0) {
      let tintLengths = [0, 0, 0, 0];
      let winner = 1;
      let highestScore = this.scores[0];
      for (let i = 0; i < this.numPlayers; i++) {
        let playerNum = i + 1;
        let playerScore = `P${playerNum}: ${this.scores[i]} `;
        finalScoreText += playerScore;
        if (this.scores[i] > highestScore) {
          winner = i + 1;
          highestScore = this.scores[i];
        }
        tintLengths[i] = playerScore.length;
      }
      this.finalScore = this.add
        .bitmapText(
          this.gameWidth / 2,
          this.gameHeight / 2 - 20,
          'pixelfont',
          finalScoreText,
          16
        )
        .setOrigin(0.5, 0.5);
      this.finalScore.setCharacterTint(0, tintLengths[0], true, 0xff2f56);
      this.finalScore.setCharacterTint(
        tintLengths[0],
        tintLengths[1],
        true,
        0x1b98e0
      );
      if (this.scores.length > 2) {
        this.finalScore.setCharacterTint(
          tintLengths[0] + tintLengths[1],
          tintLengths[2],
          true,
          0x0ead69
        );
        if (this.scores.length > 3) {
          this.finalScore.setCharacterTint(
            tintLengths[0] + tintLengths[1] + tintLengths[2],
            tintLengths[3],
            true,
            0xf2dc5d
          );
        }
      }

      // check if a tie
      let winningScores = 0;
      for (let i = 0; i < this.numPlayers; i++) {
        if (this.scores[i] == highestScore) {
          winningScores += 1;
        }
      }
      if (winningScores > 1) {
        this.finalWinner = this.add
          .bitmapText(
            this.gameWidth / 2,
            this.gameHeight / 2 + 16,
            'pixelfont',
            "It's a tie!",
            16
          )
          .setOrigin(0.5, 0.5);
      } else {
        this.finalWinner = this.add
          .bitmapText(
            this.gameWidth / 2,
            this.gameHeight / 2 + 16,
            'pixelfont',
            `Player ${winner} Wins!`,
            16
          )
          .setOrigin(0.5, 0.5);
        switch (winner) {
          case 1:
            this.finalWinner.setCharacterTint(0, -1, true, 0xff2f56);
            break;
          case 2:
            this.finalWinner.setCharacterTint(0, -1, true, 0x1b98e0);
            break;
          case 3:
            this.finalWinner.setCharacterTint(0, -1, true, 0x0ead69);
            break;
          default:
            this.finalWinner.setCharacterTint(0, -1, true, 0xf2dc5d);
        }
      }
    } else {
      finalScoreText = `Final Score: ${this.score}`;
      this.finalScore = this.add
        .bitmapText(
          this.gameWidth / 2,
          this.gameHeight / 2 - 20,
          'pixelfont',
          finalScoreText,
          16
        )
        .setOrigin(0.5, 0.5)
        .setAlpha(0.7);

      let highScore = localStorage.getItem(this.mode + ' High Score');
      if (highScore !== null && isNaN(highScore)) {
        highScore = 0;
      }
      if (!highScore || this.score > highScore) {
        highScore = this.score;
        localStorage.setItem(this.mode + ' High Score', highScore);
      }
      // this.finalHighScore = this.add
      //   .bitmapText(
      //     this.gameWidth / 2,
      //     this.gameHeight / 2 + 16,
      //     'pixelfont',
      //     'High score: ' + highScore,
      //     16
      //   )
      //   .setOrigin(0.5, 0.5)
      //   .setAlpha(0.7);
    }

    this.menuButton = this.add
      .bitmapText(
        this.gameWidth / 2,
        this.gameHeight / 2 + 140,
        'pixelfont',
        'Back to Menu',
        16
      )
      .setOrigin(0.5, 0.5)
      .setInteractive({ useHandCursor: true })
      .once('pointerup', () => this.backToMenu());
    this.menuHighlight = this.add.container(0, 0);
    this.menuHighlight.add(
      this.add
        .bitmapText(
          this.gameWidth / 2 - 64,
          this.gameHeight / 2 + 141,
          'pixelfont',
          '<',
          16
        )
        .setOrigin(0.5, 0.5)
    );
    this.menuHighlight.add(
      this.add
        .bitmapText(
          this.gameWidth / 2 + 64,
          this.gameHeight / 2 + 141,
          'pixelfont',
          '>',
          16
        )
        .setOrigin(0.5, 0.5)
    );

    /* as for the keyboard, controls are explicitly mapped to various keys
     * arrows & wasd for movement, enter / spacebar / j/k/z/x for confirm!
     */
    this.input.keyboard.on('keyup', this.handleKeyboardAction, this);

    /* set up navigation / control events
     * in the menu, any gamepad can be used, and all events are tap-based
     * movement can be done with any joystick or d-pad, and any button can be used to confirm. there is no back button!
     */
    if (this.input.gamepad.total < 1) {
      this.input.gamepad.once(
        'connected',
        function (pad) {
          this.input.gamepad.on('up', this.handleGamePadButton, this);
        },
        this
      );
    } else {
      this.input.gamepad.on('up', this.handleGamePadButton, this);
    }

    this.events.on('shutdown', this.shutdown, this);
  }

  shutdown() {
    //  We need to clear keyboard and gamepad events, or they'll stack up when the Menu is re-run
    this.input.keyboard.shutdown();
    this.input.gamepad.shutdown();
  }

  handleKeyboardAction(event) {
    event.stopPropagation(); // just in case
    switch (event.keyCode) {
      case Phaser.Input.Keyboard.KeyCodes.ENTER:
      case Phaser.Input.Keyboard.KeyCodes.J:
      case Phaser.Input.Keyboard.KeyCodes.K:
      case Phaser.Input.Keyboard.KeyCodes.SPACE:
        this.backToMenu();
        break;
    }
  }

  handleGamePadButton(pad, button, value) {
    switch (button.index) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 9:
        this.backToMenu();
        break;
    }
  }

  backToMenu() {
    this.sound.play('forward');
    this.scene.start('menu');
  }
}
